import React, { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Box } from "@material-ui/core";
import EditText from "../../components/EditText";
import Select from "../../components/Select";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  percentage: Yup.string()
    .required("Perc value is required")
    .min(0, "min 0")
    .max(100, "max 100"),
});

const EditEklokReleyForm = ({ onSubmit = () => {}, reley }) => {
  const { t } = useTranslation();
  const [realy_name, setRealyName] = useState("");

  const relayOptions = reley.map((r, i) => ({
    key: i,
    label: r.NAME,
    value: r.NAME,
    percentage: r.PERCENTAGE,
  }));
  const initial =
    relayOptions.length > 0
      ? { realy_name: relayOptions[0].label, percentage: relayOptions[0].value }
      : {};

  const handleChange = (props) => {
    if (props?.values.realy_name && realy_name !== props?.values.realy_name) {
      const new_percentage = relayOptions.find(
        (r) => r.label === props?.values.realy_name,
      )?.percentage;
      if (props.values.percentage !== new_percentage) {
        setRealyName(props.values.realy_name);
        props.setFieldValue("percentage", new_percentage);
      }
    }
  };

  return (
    <Formik
      initialValues={initial}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Grid container>
            <Grid item xs={12} sm={4} md={4} lg={3} ml={1}>
              <Box mr={2}>
                <Select
                  {...props}
                  label={t("edit_eklok_reley.name")}
                  name="realy_name"
                  values={relayOptions}
                  options={relayOptions}
                  onChange={handleChange(props)}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={3} ml={1}>
              <Box mr={2}>
                <EditText
                  {...props}
                  label={t("edit_eklok_reley.value")}
                  name="percentage"
                  type="number"
                  inputProps={{ min: 0, max: 100 }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={2}>
              <Box mt={3}>
                <Submit {...props} title={t("edit_eklok_reley.save")} />
              </Box>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default EditEklokReleyForm;
